import React from "react";
import {
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  StatusTags,
  useFormHandler,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { DropDownoptionsquickbooks } from "../../../../assets/data/projectData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  qbApiStart,
  resetAllQBData,
} from "../../../../redux/slices/quickBooks/quickBooksSlice";

const InvoicePayment = ({ setActiveTab, dropdowns }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { payments, loading } = useSelector((state) => state.quickBooks);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });
  const columns = [
    {
      key: "clientName",
      label: "Client Name",
      sortable: false,
    },
    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "referanceNumber",
      label: "Reference Number",
      sortable: false,
    },

    {
      key: "paymentDate",
      label: "Payment Date",
      sortable: false,
    },
    {
      key: "paymentMethod",
      label: "Payment Method",
      sortable: false,
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      sortable: false,
    },
    {
      key: "creditAmount",
      label: "Credit Amount",
      sortable: false,
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];

  const rowdata = [
    {
      clientName: "ABC Corp",
      businessUnit: "Tektree",
      referanceNumber: "REF-1001",
      paymentDate: "06/15/2025",
      paymentMethod: "Bank Transfer",
      receivedAmount: "50,000 USD",
      creditAmount: "0 USD",
      syncstatus: "Synced",
    },
    {
      clientName: "XYZ Ltd",
      businessUnit: "Tektree",
      referanceNumber: "REF-1002",
      paymentDate: "06/16/2025",
      paymentMethod: "Credit Card",
      receivedAmount: "30,000 USD",
      creditAmount: "500 USD",
      syncstatus: "Synced",
    },
    {
      clientName: "TechWave Inc",
      businessUnit: "Tektree",
      referanceNumber: "REF-1003",
      paymentDate: "06/17/2025",
      paymentMethod: "Cheque",
      receivedAmount: "70,000 USD",
      creditAmount: "1,000 USD",
      syncstatus: "Synced",
    },
  ];

    const fetchPayments = async () => {
      dispatch(
        qbApiStart({
          method: "GET",
          entity: "payments",
          // body: {
          //
          // },
        })
      );
    };

  //what is line in the payload for ref number??
    const mapPaymentData = (payments = []) =>
      payments.map((item) => {
        const line = item?.Line?.[0] || {};
        const metaList = line?.LineEx?.any || [];

        const referenceNumber =
          metaList.find((m) => m?.value?.Name === "txnReferenceNumber")?.value
            ?.Value || "-";

        return {
          clientName: item?.CustomerRef?.name || "-",
          businessUnit: "-",
          referanceNumber: referenceNumber,
          paymentDate: item?.TxnDate || "-",
          paymentMethod: "-", // not available in payload
          receivedAmount: item?.TotalAmt || 0,
          creditAmount: item?.UnappliedAmt || 0,
          syncstatus: item?.SyncToken ? "Synced" : "Unsynced",
        };
      });

  const mappedData = mapPaymentData(payments);

  const mappedRows = mapTableRows(mappedData, columns);
  // const mappedRows = mapTableRows(rowdata, columns);

  const handleSearch = () => {
    console.log("formData", formData);
    setActiveTab(Number(formData.Timesheets));
  };

  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <NewTableAdv
        rows={mappedRows}
        columns={columns}
        showCheckbox
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex flex-wrap gap-3 m-2">
                  {/* <DevNote>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button
                        onClick={() => fetchPayments()}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "4px",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 21C7.02944 21 3 16.9706 3 12C3 9.69494 3.86656 7.59227 5.29168 6L8 3M12 3C16.9706 3 21 7.02944 21 12C21 14.3051 20.1334 16.4077 18.7083 18L16 21M3 3H8M8 3V8M21 21H16M16 21V16"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => dispatch(resetAllQBData())}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "4px",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M10 11V17"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 11V17"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4 7H20"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </DevNote> */}
                   
                  <FormFieldSet
                    type="text"
                    noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />
                  
                    <Button title="Search" onClick={handleSearch} />
                 
                    <Button
                      title="QB Integration Profiles"
                      color="info"
                      onClick={() =>
                        navigate("/quickbooks/qb-integration-profile")
                      }
                    />
                  </div>
              
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default InvoicePayment;
